module.exports = __webpack_public_path__ + "img/ic-interieur.90be933d.svg";